import { gql } from '@apollo/client';
import { ScheduleHistoryFieldsFragment } from './fragments';

export default gql`
  query scheduleHistory($first: Int = 20, $after: Int = 0, $scheduleId: ID!) {
    scheduleHistory(
      pagination: { first: $first, after: $after }
      scheduleId: $scheduleId
    ) {
      ... on AnalysesRun {
        id
        schedule {
          ...ScheduleHistoryFields
        }
        runAt
        outcome
        screenshotUrl
        entityUrl
        createdAt
      }

      ... on BrazeCohortImportRun {
        id
        schedule {
          ...ScheduleHistoryFields
        }
        runAt
        outcome
        createdAt
        importedUsers
      }
    }
  }
  ${ScheduleHistoryFieldsFragment}
`;
